import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {Invoice} from '@app/invoice/shared/invoice';
import {RelationApi} from '@app/relation/shared/relation.api';
import {Relation} from '@app/relation/shared/relation';
import {InvoiceApi} from '@app/invoice/shared/invoice.api';
import {Payment} from '@app/payment/shared/payment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { CoreRelationComponent } from './relation.component';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
    templateUrl: 'payment-dialog.component.html',
    styleUrls: ['payment-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, CoreRelationComponent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, DecimalPipe, DatePipe]
})
export class PaymentDialogComponent {
  dialogRef = inject<MatDialogRef<PaymentDialogComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  private invoiceApi = inject(InvoiceApi);
  data = inject(MAT_DIALOG_DATA);

  invoice: Invoice;
  paymentForm: UntypedFormGroup;
  relation: Relation;

  constructor() {
    const data = this.data;
    const relationApi = inject(RelationApi);


    this.paymentForm = this.formBuilder.group({
      date: [new Date(), Validators.required],
      amount: [0, Validators.required]
    });

    this.invoice = data.invoice;

    relationApi.findByNumber(this.invoice.relationNumber).subscribe(relation => {
      this.relation = relation;
    });
  }

  get amountLeft() {
    return this.invoice.amount - this.invoice.payedAmount;
  }

  get amountLeftAfterPayment() {
    return this.invoice.amount - this.invoice.payedAmount - this.paymentForm.controls['amount'].value;
  }

  onSetAmountLeft() {
    this.paymentForm.patchValue({
      amount: this.amountLeft
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onPay() {
    const payment = new Payment();
    payment.date = this.paymentForm.value.date;
    payment.amount = this.paymentForm.value.amount;

    this.invoiceApi.payment(this.invoice.number, payment).subscribe(() => {
      this.dialogRef.close(true);
    });
  }


}
